import { generateAutomationName } from "../../../helpers/generateAutomationName";

export const dataAutomation = {
    btn: generateAutomationName("GAwidget", ["connect", "first", "party", "data", "button"]),
    container: generateAutomationName("GAwidget", ["connect", "container"]),
};
